import EF from 'ef/ef';
import Chaplin from 'chaplin';
import Group from 'ef/models/group';
import _ from 'lodash';

// # EF.Collections.GroupCollection
//
// the GroupCollection is responsible for the state and progress of groups
//
const GroupCollection = Chaplin.Collection.extend({
  model: Group,
  comparator: 'id',

  // returns module by key
  getGroupByKey: function (key) {
    return this.find(function (group) {
      return group.get('key') === key;
    });
  },

  firstIncomplete: function (groups) {
    return _.find(groups, function (group) {
      return !group.isComplete();
    });
  },

  beforeIntersession: function (groups) {
    return _.filter(groups, function (group) {
      const inter = group.get('post_intersession');
      return inter === undefined || inter === false;
    });
  },

  beforeUnlockDay: function (groups, unlockDay) {
    return _.filter(groups, function (group) {
      const groupDay = group.get('unlockDay');
      return groupDay === undefined || groupDay <= unlockDay;
    });
  },

  afterUnlockDay: function (groups, unlockDay) {
    return _.filter(groups, function (group) {
      const groupDay = group.get('unlockDay');
      return groupDay !== undefined && groupDay > unlockDay;
    });
  },

  currentGroup: function (unlockDay) {
    const pastIntersession = EF.enrollment && EF.enrollment.isPastIntersession();
    let groups = this.models;
    if (!pastIntersession) {
      groups = this.beforeIntersession(groups);
    }
    if (groups.length === 0) {
      return;
    }
    if (unlockDay !== undefined) {
      groups = this.beforeUnlockDay(groups, unlockDay);
      groups.forEach(g => g.set('dateStatus', 'past'));
      groups[groups.length - 1].set('dateStatus', 'current');
      this.afterUnlockDay(this.models, unlockDay).forEach(g => g.set('dateStatus', 'future'));
    } else {
      groups.forEach(g => g.set('dateStatus', 'current'));
    }

    return this.firstIncomplete(groups) || groups[groups.length - 1];
  },

  lockGroups: function (lockPastGroups, unlockDay) {
    const currentGroup = this.currentGroup(unlockDay);
    let currentFound = false;
    this.each(function (group) {
      if (!currentFound) {
        currentFound = group === currentGroup;
        group.set('locked', !!(lockPastGroups && !currentFound));
        if (group.get('in_order')) {
          group.modules.lockModules(group.get('dateStatus'));
        } else {
          group.modules.each(function (module) {
            module.set('locked', group.get('locked'));
            module.set('dateStatus', group.get('dateStatus'));
          });
        }
      } else {
        group.set('locked', true);
        group.modules.each(function (module) {
          module.set('locked', true);
          module.set('dateStatus', group.get('dateStatus'));
        });
      }
    });
  },
});

export default GroupCollection;
